// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hot-line-con[data-v-2beffa85]{background:#fafafa;padding:10px 20px;line-height:24px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
